export default class EmailInterfaceEvent {
    constructor(type) {
        this.type = type;
    }
}

EmailInterfaceEvent.LOCK_INTERFACE = "EmailInterfaceEvent.LOCK_INTERFACE";
EmailInterfaceEvent.UNLOCK_INTERFACE = "EmailInterfaceEvent.UNLOCK_INTERFACE";
